export default __webpack_public_path__ + "static/media/details.0b3561fb.png";